module.exports = __webpack_public_path__ + "static/media/Niveau_elN5_3_924018.34db4e4b.png";